import React, {Component} from 'react'
import {connect} from 'react-redux'
import {isInvalid, isSubmitting} from 'redux-form'
import {compose} from 'redux'
import {isNil} from 'lodash/fp'
import PropTypes from 'prop-types'
import CtaButton from './CtaButton'
import spinner from './images/spinner.gif'
import styles from './themes/default/styles.module.scss'
import withForm from '@cred/shared/hoc/with-form'

class SubmitButton extends Component {
  static propTypes = {
    submitting: PropTypes.bool,
    disabled: PropTypes.bool,
    invalid: PropTypes.bool
  }

  static defaultProps = {
    submitting: false,
    disabled: false,
    invalid: false
  }

  static displayName = 'SubmitButton'

  render() {
    const {disabled, submitting, invalid, children, ...props} = this.props

    return (
      <CtaButton
        type="submit"
        disabled={invalid || submitting || disabled}
        submitting={submitting}
        {...props}
      >
        {children} {submitting ? <img src={spinner} className={styles.spinner}/> : null}
      </CtaButton>
    )
  }
}

export const mapStateToProps = (state, {formName, submitting, invalid}) => ({
  submitting: submitting || isSubmitting(formName)(state),
  invalid: isNil(invalid) ? isInvalid(formName)(state) || isInvalid('control-form')(state) : invalid
})

export {SubmitButton as SubmitButtonNoHoc}

// eslint-disable-next-line tree-shaking/no-side-effects-in-initialization
export default compose(
  withForm,
  connect(mapStateToProps)
)(SubmitButton)
